import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { mutationDeleteChannel } from "Apollo";
import { ShowNotice } from "Store";
import Icon from "module-common/Icon";
import ConfirmModal from "module-common/ConfirmModal";

export default graphql(mutationDeleteChannel)(
  class DeleteButton extends Component {
    static propTypes = { id: PropTypes.number };
    state = { showModal: false };

    render() {
      return [
        <Icon
          name="x-button-gray"
          mode="contain"
          width={13}
          height={13}
          onClick={() => this.setState({ showModal: true })}
        />,
        this.state.showModal && (
          <ConfirmModal
            key="modal"
            text="Do you want to delete this channel?"
            onCancel={() => this.setState({ showModal: false })}
            onConfirm={this.onConfirm}
          />
        )
      ];
    }

    onConfirm = () => {
      try {
        this.props.mutate({
          variables: {
            companyChannelHandlerArg: {
              id: this.props.id
            }
          },
          refetchQueries: ["getChannels"]
        });
        this.setState({ showModal: false });
        ShowNotice("channel-delete-success");
      } catch (error) {
        ShowNotice("channel-delete-error");
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-first-time/connect-account/DeleteButtonWithMutation.js